import { NewShippingAddress } from './components/NewShippingAddress';
import { ShippingAddressesList } from './components/ShippingAddressesList';
import { ShippingAddressSuggestions } from './components/suggestions/ShippingAddressSuggestions';
import { ShippingAddressUiProvider, useShippingAddressUi } from './ShippingAddressUiProvider';

interface Props {
  header?: string;
}

const ShippingAddressesModuleContent = ({ header }: Props) => {
  const { displayMode } = useShippingAddressUi();

  return (
    <>
      {displayMode === 'LIST' && <ShippingAddressesList header={header} />}
      {displayMode === 'NEW' && <NewShippingAddress header={header} />}
      {displayMode === 'SUGGESTION' && <ShippingAddressSuggestions header={header} />}
    </>
  );
};

export const ShippingAddressesModule = ({ header }: Props) => (
  <ShippingAddressUiProvider>
    <ShippingAddressesModuleContent header={header} />
  </ShippingAddressUiProvider>
);
